export default __webpack_public_path__ + "Coupon_Barcode.34ddde34da0c7ed03e3a5b6b309b7483.png";